import {Link, useNavigate, useOutletContext} from "react-router-dom"

import MobileDropdownMenu from "../components/navigation/MobileDropdownMenu"
import OarsLogo from "../static/img/oars-logo.svg"

const MobileMenuPage = () => {
    const navigate = useNavigate()
    const {darkMode, setDarkMode} = useOutletContext() || {}

    const handleClose = () => {
        // Return to the page the user came from, or home as a fallback.
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate("/home")
        }
    }

    return (
        <div className="d-flex flex-column vh-100">
            <header className="header app-header">
                <div className="app-header-primary container-fluid d-flex align-items-center justify-content-between">
                    <Link to="/home" className="text-white fs-4 fw-medium text-decoration-none">
                        <OarsLogo className="h-25px logo" />
                    </Link>
                    <button
                        type="button"
                        onClick={handleClose}
                        className="btn btn-icon btn-active-color-primary w-40px h-40px"
                        title="Close menu"
                        aria-label="Close menu"
                    >
                        <i className="fas fa-xmark fs-1 text-white"></i>
                    </button>
                </div>
            </header>

            <div className="flex-grow-1 overflow-auto py-4">
                <MobileDropdownMenu darkMode={darkMode} setDarkMode={setDarkMode} fullPage />
            </div>
        </div>
    )
}

export default MobileMenuPage
